/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { object, string } from "prop-types";
import CollectionTitle from "../../atoms/CollectionTitle";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { DfpComponent } from "../../ads/dfp-component";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";
import SubHeadline from "../../atoms/SubHeadline";
import { RowSeparator } from "../../atoms/RowSeparator";
import { useDeviceType } from "../../custom-hooks/useDeviceType";

import "./one-col-one.m.css";

const StoryCard = ({ story, showSeparator, showTimestamp, showReadTime, showSubHeadline, sectionSlug }) => {
  const headline = getStoryHeadline(story);
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl || `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  const label = getStoryLabel(story);
  const imageUrl =
    get(story, ["hero-image-s3-key"]) ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]);
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";
  return (
    <Link href={href} target={target}>
      <div styleName="story-card">
        <HeroImage
          story={story}
          widths={[350]}
          headline={headline}
          aspectRatio={[[16, 9]]}
          iconSizes={isMobile ? { width: 32, height: 32 } : { width: 64, height: 64 }}
          imageUrl={imageUrl}
        />
        {label && <Label story={story} />}

        {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
        {showSubHeadline && story.subheadline && (
          <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
        )}
        <PublishAndReadTime story={story} showTimestamp={showTimestamp} showReadTime={showReadTime} />
      </div>
    </Link>
  );
};

export default function OneColOneStory({ collection, stories, extraProp = "" }) {
  const {
    show_row_separator,
    show_timestamp,
    show_read_time,
    show_row_title,
    show_subheadline,
    enable_sponsor_ad,
    sponsor_ad_details,
    show_row_ad_unit_bottom,
  } = get(collection, ["associated-metadata"], {});
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));

  const rowAdBottom = show_row_ad_unit_bottom?.split("/").slice(-1)[0];
  const rowAdBottomDivId = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "ad_div_mapping", rowAdBottom], "")
  );
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], null));
  const sectionSlug = extraProp;
  if (stories.length === 0) return null;
  return (
    <div className="row-component" styleName="one-col-one-story">
      <div styleName="title">
        {show_row_title && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enable_sponsor_ad}
            sponsorAdDetails={sponsor_ad_details}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
          />
        )}
      </div>
      <div styleName="stories-container">
        <StoryCard
          key={stories[0].id}
          story={stories[0]}
          showTimestamp={show_timestamp}
          showReadTime={show_read_time}
          showSubHeadline={show_subheadline}
          sectionSlug={sectionSlug}
        />
      </div>
      {show_row_separator && <RowSeparator />}
      {show_row_ad_unit_bottom && <DfpComponent adStyleName="ad-slot-size-300x250" id={rowAdBottomDivId} />}
    </div>
  );
}
OneColOneStory.propTypes = {
  collection: object.isRequired,
  extraProp: string,
};
